<template>
  <div class="job-poster-page">
    <slot name="poster-before" :jobPosterList="jobPosterList" :loadJobPoster="loadJobPoster"></slot>
    <slot name="poster-content" :jobPosterList="jobPosterList">
      <div v-if="showJobPosterContent" v-rect-loading="loadJobPoster" class="job-poster">
        <div
          v-for="(jobPoster, index) in jobPosterList"
          class="poster-preview-container"
          :key="index"
        >
          <div class="image-container" :class="isPreview && 'preview'">
            <div v-if="isVideoPoster(jobPoster)" class="icon-video-play">
              <div class="image-overlay" @click="showJobPosterDialog(jobPoster)"></div>
              <img class="play-icon" src="@/assets/image/jobDetail/play.png" @click="showJobPosterDialog(jobPoster)"/>
            </div>
            <div class="image-wrapper">
              <img :src="jobPoster.posterShareImg" @click="showJobPosterDialog(jobPoster)"/>
            </div>
          </div>
        </div>
      </div>
    </slot>
    <DialogWrapper
      class="job-poster-dialog"
      hideFooter
      appendToBody
      :closeOnClickModal="false"
      :show.sync="jobPosterDialog.show"
      :loading="jobPosterDialog.loading"
      @closed="handleClosedJobPosterDialog"
    >
      <div class="job-poster-share">
        <div class="job-poster-layout">
          <div v-if="!detailPoster" class="job-poster-list">
            <div v-for="(item, index) in posterShowTypes" class="job-poster-item" :key="index">
              <div class="header">
                <span class="label">{{ item.label }}</span>
                <span v-if="getCurrentPosterList(item.value).length > 4 && posterShowTypes.length > 1" class="view-more" @click="handleShowViewMore(item)">{{ $t(`${i18nPrefix}.label.viewMore`) }}</span>
              </div>
              <div class="preview-content">
                <div v-for="jobPoster in item.data" class="image-container" :class="currentPopPoster === jobPoster && 'is_active'" :key="`${jobPoster.ambassador_poster_id}-${jobPoster.id}`">
                  <div v-if="isVideoPoster(jobPoster)" class="icon-video-play">
                    <div class="image-overlay" @click="onPosterPreviewClick(jobPoster)"></div>
                    <img class="play-icon" src="@/assets/image/jobDetail/play.png" @click="onPosterPreviewClick(jobPoster)"/>
                  </div>
                  <div
                    class="image-wrapper"
                    :style="{ backgroundImage: `url(${jobPoster.posterShareImg})` }"
                    @click="onPosterPreviewClick(jobPoster)"
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="job-poster-detail">
            <div class="header">
              <i v-if="posterShowTypes.length > 1" class="back el-icon-arrow-left" @click="handleHiddenViewMore"></i>
              <span class="label">{{ detailPoster.label }}</span>
            </div>
            <div class="preview-content">
              <div v-for="jobPoster in getCurrentPosterList(detailPoster.value)" class="image-container" :class="currentPopPoster === jobPoster && 'is_active'" :key="`${jobPoster.ambassador_poster_id}-${jobPoster.id}`">
                <div v-if="isVideoPoster(jobPoster)" class="icon-video-play">
                  <div class="image-overlay" @click="onPosterPreviewClick(jobPoster)"></div>
                  <img class="play-icon" src="@/assets/image/jobDetail/play.png" @click="onPosterPreviewClick(jobPoster)"/>
                </div>
                <div
                  class="image-wrapper"
                  :style="{ backgroundImage: `url(${jobPoster.posterShareImg})` }"
                  @click="onPosterPreviewClick(jobPoster)"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="job-poster-content">
          <div class="poster" ref="posterView">
            <video
              v-if="isVideoPoster(currentPopPoster)"
              ref="poster-video"
              class="poster-video"
              id="poster-video"
              preload="auto"
              controls
              controlslist="nodownload noremoteplayback"
              :style="{ objectFit: 'cover' }"
              :src="currentPopPoster.originVideoSrc"
              :poster="currentPopPoster.posterShareImg"
              @loadedmetadata="onVideoLoaded"
            >
            </video>
            <img v-else class="poster-img" :src="posterImgUrl"/>
          </div>
          <div class="btn-group">
            <el-upload
              v-if="currentPosterShowType === 'CUSTOM'"
              class="poster-upload btn"
              action=""
              :accept="currentPopPoster.poster_type === 'video' ? 'video/*' : 'image/*'"
              :show-file-list="false"
              :limit="1"
              :before-upload="beforeUploadPoster"
              :http-request="handleUploadPoster"
            >
              <el-button class="upload-btn">{{ $t(`${i18nPrefix}.btn.${isVideoPoster(currentPopPoster)? 'editVideoJobPoster' : 'editImgJobPoster'}`) }}</el-button>
            </el-upload>
            <el-popconfirm
              v-if="currentPosterShowType === 'AMBASSADOR_POSTER'"
              :title="$t('common.message.confirmDelete')"
              @confirm="handleDeletePoster"
            >
              <template #reference>
                <el-button class="btn">{{ $t(`${i18nPrefix}.btn.delete`) }}</el-button>
              </template>
            </el-popconfirm>
            <el-button v-if="!(currentPosterShowType === 'CUSTOM' || currentPosterShowType === 'INSTRUCTIONS')" class="btn download-btn" @click="handleDownloadPoster">{{ $t(`${i18nPrefix}.btn.download`) }}</el-button>
          </div>
        </div>
        <VueCanvasPoster
          :widthPixels="1000"
          :painting="painting"
          @success="successCreateImg"
          @fail="fail">
        </VueCanvasPoster>
        <div v-show="false">
          <VueQr
            :logoSrc='posterQrcode.logoSrc'
            :text="posterQrcode.text"
            :size="200"
            :qid="qrcodeQidStr"
            :callback="savePreviewQRcodeUrl">
          </VueQr>
        </div>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import VueQr from 'vue-qr'
import { VueCanvasPoster } from 'vue-canvas-poster'
import { ACCEPT_FILE_SIZE, ACCEPT_VIDEO_DURATION_SECONDS, ACCEPT_VIDEO_FILE_SIZE, JOB_POSTER_SHOW_TYPE } from '@/constant/jobPoster'
import { base64SrcToBlob, md5 } from '@/utils/common'
import { dataUrlToFile, getBindImageHeight, preCompressImage, resizeDataURL, uploadBase64Src, uploadFile } from '@/utils/qiniu'
import { mapActions, mapGetters } from 'vuex'
import { isEn } from '@/i18n'

export default {
  components: {
    DialogWrapper,
    VueQr,
    VueCanvasPoster
  },
  props: {
    showJobPosterContent: {
      type: Boolean,
      default: true
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    jobDetailInfo: {
    },
    shareLink: {
      required: true
    },
    company: {
      required: true
    },
    jobList: {
      type: Array
    },
    initJobPosters: {
      default: null
    }
  },
  inject: ['getCustomFontFromTheme'],
  data () {
    return {
      isEn,
      ...mapGetters('account', ['getCurrentAccount', 'getCurrentSoftUser']),
      i18nPrefix: 'admin.job.editor',
      loadJobPoster: false,
      jobPosterList: [],
      commonPosterList: [],
      customPosterList: [],
      instructionsPosterList: [],
      ambassadorPosterList: [],
      detailPoster: null,
      isAmbassador: false,
      currentPopPoster: null,
      posterQrcode: {
        logoSrc: null,
        text: 'www.ajinga.com',
        url: null
      },
      jobPosterDialog: {
        show: false,
        loading: false
      },
      posterImgUrl: null,
      posterPaintingPromise: null,
      posterPaintingPromiseResolve: null,
      qrCodePromise: null,
      qrCodePromiseResolve: null,
      painting: {},
      qrcodeQid: 0,
      isGeneratingVideo: false,
      isGeneratingBgImagePosterId: null,
      currentPosterShowType: null
    }
  },
  computed: {
    posterShowTypes () {
      const list = [
        {
          label: this.$t('admin.company.jobPoster.label.companyJobPoster'),
          value: 'COMMON',
          hidden: !this.commonPosterList.length,
          data: _.filter(this.commonPosterList, (item, index) => index < 4)
        },
        {
          label: this.$t('admin.company.jobPoster.label.ambassadorJobPoster'),
          value: 'AMBASSADOR_POSTER',
          hidden: !this.isAmbassador || !this.ambassadorPosterList.length,
          data: _.filter(this.ambassadorPosterList, (item, index) => index < 4)
        },
        {
          label: this.$t('admin.company.jobPoster.label.customJobPoster'),
          value: 'CUSTOM',
          hidden: !this.isAmbassador || !this.customPosterList.length,
          data: _.filter(this.customPosterList, (item, index) => index < 4)
        },
        {
          label: this.$t('admin.company.jobPoster.label.instructionsJobPoster'),
          value: 'INSTRUCTIONS',
          hidden: !this.isAmbassador || !this.instructionsPosterList.length,
          data: _.filter(this.instructionsPosterList, (item, index) => index < 4)
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    qrcodeQidStr () {
      return this.qrcodeQid.toString()
    },
    shortUniqueId () {
      return this.jobDetailInfo?.short_unique_id || _.get(this.jobList, '0.short_unique_id')
    }
  },
  async created () {
    if (this.shortUniqueId) {
      await this.checkCurrentAccountIsAmbassador()
    }
    this.loadJobPoster = true
    if (this.initJobPosters) {
      const initJobPosters = _.cloneDeep(this.initJobPosters)
      await this.formatJobPoster(initJobPosters, this.shareLink)
    } else {
      await this.loadJobPosterInfo(this.shareLink)
    }
    this.loadJobPoster = false
    if (this.posterShowTypes.length === 1) {
      this.detailPoster = this.posterShowTypes[0]
    }
  },
  methods: {
    ...mapActions('job', ['getJobDetailJobPoster', 'countShareTimes']),
    ...mapActions('common', ['watermarkVideo', 'getMediaInfo', 'getMediaPrefopStatus', 'batchDeletePosterImage']),
    ...mapActions('jobPosterAmbassador', ['checkAccountIsAmbassador', 'uploadAmbassadorJobPoster', 'deleteAmbassadorJobPoster']),
    async loadJobPosterInfo (link) {
      this.jobPosterList = []
      this.commonPosterList = []
      this.customPosterList = []
      this.instructionsPosterList = []
      this.ambassadorPosterList = []
      this.loadJobPoster = true
      const params = {
        company_id: this.company.id,
        language_code: this.isEn() === 'en' ? 'en' : 'cn'
      }
      try {
        const resp = await this.getJobDetailJobPoster(params)
        if (resp) {
          const jobPosters = resp.job_poster_list
          await this.formatJobPoster(jobPosters, link)
        }
      } finally {
        this.loadJobPoster = false
      }
    },
    async fetchJobPoster () {
      this.$emit('fetchJobPoster')
      await this.loadJobPosterInfo(this.shareLink)
    },
    async formatJobPoster (jobPosters, link) {
      if (!jobPosters || !jobPosters.length) {
        this.showJobPoster = false
        return
      }
      this.showJobPoster = true
      let imagePosterCount = 0
      let videoPosterCount = 0
      const jobPosterList = []
      for (const jobPoster of jobPosters) {
        jobPoster.bg_size = JSON.parse(jobPoster.bg_size)
        jobPoster.content_configuration = JSON.parse(jobPoster.content_configuration)
        jobPoster.qrcode_configuration = JSON.parse(jobPoster.qrcode_configuration)
        const showType = jobPoster.show_type
        if (showType === 'AMBASSADOR_POSTER' && jobPoster.poster_type === 'video') {
          let posterShareImg = '@/assets/image/jobDetail/StuxShareImage.png'
          if (jobPoster.share_img_url) {
            posterShareImg = `${process.env.VUE_APP_QINIU_DOMAIN}${jobPoster.share_img_url}?vframe/jpg/offset/0`
          }
          jobPoster.posterShareImg = posterShareImg
        } else {
          jobPoster.posterShareImg = jobPoster.share_img_url ? this.getSourcePath(jobPoster.share_img_url) : '@/assets/image/jobDetail/StuxShareImage.png'
        }
        jobPoster.posterQrcode = {
          text: this.getPosterQrcodeUrl(link)
        }
        if (jobPoster.qrcode_configuration.haveLogo) {
          const urlState = await this.checkUrlIsValid(this.$DjangoBaseUrl(this.company.logo))
          if (urlState) {
            jobPoster.posterQrcode.logoSrc = this.$DjangoBaseUrl(this.company.logo)
          } else {
            jobPoster.posterQrcode.logoSrc = require('@/assets/image/jobDetail/blank-logo.png')
          }
        }
        if (jobPoster.poster_type === 'img') {
          jobPosterList.push(jobPoster)
          this.addJobPosterByShowType(showType, jobPoster)
          if (imagePosterCount === 1) {
            continue
          }
          imagePosterCount += 1
        } else if (jobPoster.poster_type === 'video') {
          jobPoster.originVideoSrc = this.getSourcePath(jobPoster.bg_source_url)
          jobPoster.poster_unique_key = this.generateVideoPosterUniqueKey(jobPoster)
          jobPoster.videoInfo = {}
          try {
            const resp = await this.getMediaInfo(jobPoster.bg_source_url)
            if (resp?.streams.length > 0) {
              const newVideoInfo = resp.streams[0]
              jobPoster.videoInfo = {
                width: newVideoInfo.width,
                height: newVideoInfo.height,
                displayAspectRatio: newVideoInfo.display_aspect_ratio || `${newVideoInfo.width.toString()}/${newVideoInfo.height.toString()}`
              }
            }
          } catch {
          }
          jobPosterList.push(jobPoster)
          this.addJobPosterByShowType(showType, jobPoster)
          if (videoPosterCount === 1) {
            continue
          }
          videoPosterCount += 1
        }
      }
      if (this.isAmbassador) {
        this.jobPosterList = _.take(_.filter(jobPosterList, item => item.show_type !== 'AMBASSADOR'), 2)
      } else {
        this.jobPosterList = _.take(_.filter(jobPosterList, item => item.show_type === 'COMMON'), 2)
      }
      if (!this.jobPosterList.length) {
        this.showJobPoster = false
      }
    },
    handleShowViewMore (posterShowType) {
      this.detailPoster = posterShowType
      const clickType = posterShowType.value
      if (this.currentPosterShowType !== clickType) {
        this.onPosterPreviewClick(this.getCurrentPosterList(clickType)[0])
      }
    },
    handleHiddenViewMore () {
      this.detailPoster = null
    },
    async checkCurrentAccountIsAmbassador () {
      if (this.isPreview) {
        return
      }
      const resp = await this.checkAccountIsAmbassador({ job_short_id: this.shortUniqueId })
      this.isAmbassador = resp
    },
    showJobPosterDialog (jobPoster) {
      if (this.isPreview) {
        return
      }
      this.onPosterPreviewClick(jobPoster)
      this.jobPosterDialog.show = true
      this.$emit('showPosterDialog')
    },
    handleClosedJobPosterDialog () {
      this.$emit('closedPosterDialog')
    },
    async handleDeletePoster () {
      const jobPoster = this.currentPopPoster
      if (!jobPoster.ambassador_poster_id) {
        return
      }
      this.posterTransitionShow = false
      this.jobPosterDialog.loading = true
      try {
        const resp = await this.deleteAmbassadorJobPoster({ companyId: this.company.id, ambassadorPosterId: jobPoster.ambassador_poster_id })
        let msg = ''
        if (resp) {
          msg = `${this.i18nPrefix}.message.deleteAmbassadorPosterSuccess`
        } else {
          msg = `${this.i18nPrefix}.message.deleteAmbassadorPosterFail`
        }
        this.$message.info({
          message: this.$t(msg),
          customClass: 'message-override'
        })
      } finally {
        this.posterImgUrl = null
        this.currentPopPoster = null
        await this.fetchJobPoster()
        const posterList = this.getCurrentPosterList(this.currentPosterShowType)
        if (posterList.length) {
          this.onPosterPreviewClick(posterList[0])
        } else if (this.jobPosterList.length > 0) {
          this.detailPoster = null
          this.onPosterPreviewClick(this.jobPosterList[0])
        } else {
          this.jobPosterDialog.show = false
        }
        this.jobPosterDialog.loading = false
      }
    },
    addJobPosterByShowType (showType, jobPoster) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        this.commonPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        this.customPosterList.push(jobPoster)
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        this.instructionsPosterList.push(jobPoster)
      } else {
        this.ambassadorPosterList.push(jobPoster)
      }
    },
    getPosterQrcodeUrl (path) {
      let url = null
      if (path.indexOf('?') === -1) {
        url = path + '?aj_source=JDpage&aj_code=Jobposter'
      } else {
        const strList = path.split('?')
        const params = strList[1].split('&')
        url = strList[0]
        url += '?aj_source=JDpage&aj_code=Jobposter'
        params.forEach(item => {
          if (item.indexOf('aj_source') === -1 && item.indexOf('aj_code') === -1) {
            url += '&'
            url += item
          }
        })
      }
      return url
    },
    savePreviewQRcodeUrl (url, id) {
      if (this.qrCodePromise && this.qrCodePromiseResolve) {
        this.qrCodePromiseResolve()
      }
      this.posterQrcode.url = url
    },
    checkUrlIsValid (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = url
        img.onload = (res) => {
          resolve(true)
        }
        img.onerror = () => {
          resolve(false)
        }
      })
    },
    async onPosterPreviewClick (jobPoster) {
      this.currentPosterShowType = jobPoster.show_type
      this.activePosterShowTypeIndex = _.findIndex(this.posterShowTypes, showType => showType.value === jobPoster.show_type)
      this.currentPopPoster = jobPoster
      if (this.isVideoPoster(jobPoster)) {
        if (!jobPoster.videoKeyAfterCompound) {
          this.isGeneratingVideo = true
        }
      }
      if (!jobPoster.bgImageSrc) {
        this.painting = {}
        await this.generateBgImage(jobPoster)
      }
      if (!this.isVideoPoster(jobPoster)) {
        this.posterImgUrl = this.currentPopPoster.bgImageSrc
      }
      if (this.jobDetailInfo) {
        this.countShareTimesWithSite('wechat')
      }
      this.$refs.posterView?.scrollTo({ top: 0 })
    },
    setDefaultImage (e) {
      e.target.src = require('@/assets/image/microSite/imageBig.png')
    },
    async generateBgImage (jobPoster) {
      const posterId = this.currentPosterShowType === 'AMBASSADOR_POSTER' ? 'ambassador_poster_id' : 'id'
      const job = this.jobDetailInfo
      this.isGeneratingBgImagePosterId = _.get(jobPoster, posterId)
      this.posterQrcode.logoSrc = jobPoster.posterQrcode.logoSrc
      if (jobPoster.posterQrcode.text) {
        this.posterQrcode.text = jobPoster.posterQrcode.text
      }
      this.qrCodePromise = new Promise((resolve, reject) => {
        this.qrCodePromiseResolve = resolve
      })
      this.posterPaintingPromise = new Promise((resolve, reject) => {
        this.posterPaintingPromiseResolve = resolve
        const painting = {
          width: (jobPoster.bg_size.X | 1) + 'px',
          height: (jobPoster.bg_size.Y | 1) + 'px',
          background: this.getSourcePath(this.isVideoPoster(jobPoster) ? jobPoster.watermark_bg_url : jobPoster.bg_source_url),
          views: []
        }

        jobPoster.content_configuration.forEach(item => {
          if (item.data.status) {
            let fontFamily = item.data.font
            if (item.data.customFont) {
              /**
               *  vue-canvas-poster组件中的fontFamily的值只支持设置单个
               *  去除自定义字体前后的 " 使该组件支持多个fontFamily
               *  例如： vue-canvas-poster组件中fontFamily的应用为 font: 12px "{fontFamily}"
               *      若 fontFamily = "宋体", "Arial", "sans-serif" 则 => font: 12px ""宋体", "Arial", "sans-serif"" 不符合规则
               */
              fontFamily = this.getCustomFontFromTheme()?.slice(1, -1)
            }
            const viewItem = {
              type: 'text',
              css: {
                left: (item.data.X | 0) + 'px',
                top: (item.data.Y | 0) + 'px',
                fontSize: (item.data.size | 0) + 'px',
                lineHeight: (item.data.size | 0) + 6 + 'px',
                fontFamily: fontFamily,
                fontWeight: item.data.fontBold,
                width: (item.data.MaxWidth | 0) + 'px',
                color: item.data.color,
                textAlign: item.data.centerAlign ? 'center' : 'left',
                maxLines: 2
              }
            }
            if (item.name === 'jobName') {
              const jobName = job ? job.i18nName : this.$t('companyJobList.message.multipleJobs')
              const textArray = this.handleLineBreak(item, jobName, fontFamily)
              if (textArray.length > 1) {
                const viewItem1 = {
                  type: 'text',
                  text: textArray[0],
                  css: {
                    left: (item.data.X | 0) + 'px',
                    top: (item.data.Y | 0) + 'px',
                    fontSize: (item.data.size | 0) + 'px',
                    lineHeight: (item.data.size | 0) + 6 + 'px',
                    fontFamily: fontFamily,
                    fontWeight: item.data.fontBold,
                    width: (item.data.MaxWidth | 0) + 'px',
                    color: item.data.color,
                    textAlign: item.data.centerAlign ? 'center' : 'left',
                    maxLines: 1
                  }
                }
                const viewItem2 = {
                  type: 'text',
                  text: textArray[1],
                  css: {
                    left: (item.data.X | 0) + 'px',
                    top: (item.data.Y | 0) + (item.data.size | 0) + 6 + 'px',
                    fontSize: (item.data.size | 0) + 'px',
                    lineHeight: (item.data.size | 0) + 6 + 'px',
                    fontFamily: fontFamily,
                    fontWeight: item.data.fontBold,
                    width: (item.data.MaxWidth | 0) + 'px',
                    color: item.data.color,
                    textAlign: item.data.centerAlign ? 'center' : 'left',
                    maxLines: 1
                  }
                }
                painting.views.push(viewItem1)
                painting.views.push(viewItem2)
              } else {
                viewItem.css.maxLines = 2
                viewItem.text = jobName
                painting.views.push(viewItem)
              }
            } else if (item.name === 'city') {
              if (!job) {
                viewItem.text = this.$t('companyJobList.message.multipleLocations')
              } else if (job.cities.length === 1) {
                viewItem.text = job.cities[0].name
              } else if (job.cities.length > 1) {
                viewItem.text = this.$t('jobDetail.moreCity', { city1: job.cities[0].name, city2: job.cities[1].name })
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            } else if (item.name === 'companyName') {
              viewItem.css.maxLines = 1
              viewItem.text = this.company.i18nName
              painting.views.push(viewItem)
            } else if (item.name === 'distinct') {
              if (!job) {
                return
              }
              if (job.distinct.length === 1) {
                viewItem.text = job.distinct[0]
              } else if (job.distinct.length > 1) {
                viewItem.text = this.$t('jobDetail.moreDistinct', { distinct1: job.distinct[0], distinct2: job.distinct[1] })
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            } else if (item.name === 'address') {
              if (!job) {
                return
              }
              if (job.address.length === 1) {
                viewItem.text = job.address[0]
              } else if (job.address.length > 1) {
                viewItem.text = job.address[0] + this.$t('jobDetail.moreAddress')
              } else {
                viewItem.text = ''
              }
              viewItem.css.maxLines = 1
              painting.views.push(viewItem)
            }
          }
        })

        // add qrcode
        const qrcodeConfiguration = jobPoster.qrcode_configuration
        this.qrcodeQid += 1
        return this.qrCodePromise.then(() => {
          const qrcodeView = {
            type: 'image',
            url: this.posterQrcode.url,
            css: {
              width: (qrcodeConfiguration.width | 0) + 'px',
              height: (qrcodeConfiguration.width | 0) + 'px',
              left: (qrcodeConfiguration.X | 0) + 'px',
              top: (qrcodeConfiguration.Y | 0) + 'px'
            }
          }
          if (qrcodeConfiguration.roundedCorners) {
            qrcodeView.css.borderRadius = Number(qrcodeConfiguration.width | 0) * 0.05 + 'px'
          }
          painting.views.push(qrcodeView)
          this.painting = painting
        })
      })
      return Promise.all([this.qrCodePromise, this.posterPaintingPromise])
    },
    handleLineBreak (item, text, fontFamily) {
      const textArray = []
      const strList = text.split(' ')
      if (strList.length === 1) {
        return strList
      }
      const maxWidth = item.data.MaxWidth | 0
      if (maxWidth === 0) {
        textArray[0] = text
        return textArray
      }
      const divEl = document.createElement('div')
      divEl.style.position = 'absolute'
      divEl.style.left = '-99999px'
      divEl.style.lineHeight = (item.data.size | 0) + 6 + 'px'
      divEl.style.fontWeight = item.data.fontBold
      divEl.style.fontSize = (item.data.size | 0) + 'px'
      divEl.style.fontFamily = fontFamily
      if (item.data.fontBold) {
        divEl.style.fontWeight = 'bold'
      }
      document.body.appendChild(divEl)
      let lastTextlength = 0 // 上一次截取的位置
      let noShowStr = text // 未被截取的字符串
      for (let i = 0; i < strList.length; i++) {
        const substrIndex = noShowStr.indexOf(strList[i]) + strList[i].length
        const innerText = text.substring(0, lastTextlength + substrIndex)
        noShowStr = text.substring(lastTextlength + substrIndex)
        divEl.innerText = innerText
        if (divEl.clientWidth > maxWidth) {
          // 当前长度大于max时，最后加的子串是全英文或者全数字时，取上一次截取结果作为第一行。
          const isEnglishWorld = /^[a-zA-Z]|\d+$/.test(strList[i])
          const isSpecialChar = /^[^%&',;=?$\x22]+$/.test(strList[i])
          if (i === 0) {
          } else if (isEnglishWorld || isSpecialChar) {
            textArray[0] = text.substring(0, lastTextlength)
            textArray[1] = text.substring(lastTextlength).trim()
          } else {
            textArray[0] = text
          }
          divEl.remove()
          return textArray
        }
        lastTextlength = lastTextlength + substrIndex
      }
      divEl.remove()
      textArray[0] = text
      return textArray
    },
    getSourcePath (path) {
      if (!path || path.includes('http')) {
        return path
      } else {
        return `${process.env.VUE_APP_QINIU_DOMAIN}${path}?v=${new Date().getTime()}`
      }
    },
    isVideoPoster (jobPoster) {
      return jobPoster && jobPoster.poster_type === 'video'
    },
    successCreateImg (src) {
      const currentPosterList = this.getCurrentPosterList(this.currentPosterShowType)
      const posterId = this.currentPosterShowType === 'AMBASSADOR_POSTER' ? 'ambassador_poster_id' : 'id'
      const currentGenerateBgImgPoster = currentPosterList.find((item) => _.get(item, posterId) === this.isGeneratingBgImagePosterId)
      if (!currentGenerateBgImgPoster) {
        return
      }
      // 合成后的图片，不论是图片海报的还是视频海报需要的图片都存起来
      currentGenerateBgImgPoster.bgImageSrc = src
      if (this.posterPaintingPromise && this.posterPaintingPromiseResolve) {
        this.posterPaintingPromiseResolve(src)
      }
      if (this.isGeneratingVideo && this.isVideoPoster(this.currentPopPoster)) {
        this.$message.info({
          message: this.$t('jobDetail.videoIsGenerating'),
          customClass: 'message-override'
        })
        this.handleVideoCompound(src, this.currentPopPoster)
      } else {
        this.posterImgUrl = src
      }
      this.isGeneratingBgImagePosterId = null
    },
    fail (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    },
    generateFileKey (language, type) {
      const fileKeyPrefix = 'job-poster/'
      const account = this.getCurrentAccount()
      const softUser = this.getCurrentSoftUser()
      const accountId = account.id || softUser?.id || `noaccount${parseInt(Math.random() * 1000)}`
      return `${fileKeyPrefix}${this.company.id}-${accountId}-${language}-${type}-${new Date().valueOf()}`
    },
    async handleVideoCompound (previewImageSrc, jobPoster) {
      const lang = this.isEn() === 'en' ? 'en' : 'cn'
      const imageFileKey = this.generateFileKey(lang, 'uservideoimage')
      const imageWidth = jobPoster.bg_size.X
      const imageHeight = jobPoster.bg_size.Y
      const videoPosterType = jobPoster.watermark_bg_location
      const videoInfo = jobPoster.videoInfo
      const videoFileKey = jobPoster.bg_source_url
      if (!videoFileKey) {
        return
      }
      if (videoPosterType === 'tail') {
        const displayAspectRatio = videoInfo.displayAspectRatio
        const aspectHeight = getBindImageHeight(displayAspectRatio, imageWidth, imageHeight)
        const resizeSrcFile = await dataUrlToFile(previewImageSrc, 'test')
        // 压缩预处理图片，否则图片拼接视频不成功
        const blob = await preCompressImage(resizeSrcFile, imageWidth, aspectHeight)
        await uploadFile(blob, imageFileKey)
      } else {
        const resizeSrc = await resizeDataURL(previewImageSrc, imageWidth, imageHeight)
        await uploadBase64Src(imageFileKey, resizeSrc)
      }
      // 调后台接口, 传imageFileKey, videoFileKey, videoPosterType, 后台调七牛接口合成视频, 将合成后的视频url传给前台并显示。
      const params = {
        imageKey: imageFileKey,
        videoKey: videoFileKey,
        resolution: videoInfo,
        location: videoPosterType,
        posterUniqueKey: this.getVideoPosterUniqueKey(jobPoster)
      }
      const resp = await this.watermarkVideo(params)
      const { persistentId, lastUrl } = resp
      if (persistentId) {
        this.getVideoStatus(persistentId, imageFileKey, jobPoster)
      } else if (lastUrl) {
        jobPoster.videoKeyAfterCompound = lastUrl
        this.isGeneratingVideo = false
      }
    },
    getVideoStatus (persistentId, imageKey, jobPoster) {
      setTimeout(async () => {
        const posterUniqueKey = this.getVideoPosterUniqueKey(jobPoster)
        const params = {
          persistentId,
          posterUniqueKey
        }
        const resp = await this.getMediaPrefopStatus(params)
        if (resp.code > 2) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.operateFailed')
          })
          this.isGeneratingVideo = false
          return
        }
        if (resp.code !== 0) {
          this.getVideoStatus(persistentId, imageKey, jobPoster)
          return
        }
        if (resp?.items.length > 0) {
          const newVideoKey = resp.items[0].key
          jobPoster.videoKeyAfterCompound = newVideoKey
          this.isGeneratingVideo = false
          imageKey && this.batchDeletePosterImage({ invalid_keys: [imageKey] })
        }
      }, 2000)
    },
    // TODO 未来如果多视频海报，这里需要修改
    getVideoPosterUniqueKey (jobPoster) {
      const posterUniqueKey = jobPoster.poster_unique_key
      return posterUniqueKey
    },
    // 用于后台缓存同一用户对同一职位的合成视频
    generateVideoPosterUniqueKey (jobPoster) {
      const bgSourceUrl = jobPoster.bg_source_url
      const bgSize = jobPoster.bg_size
      const contentConfiguration = jobPoster.content_configuration
      const qrcodeUrl = jobPoster.posterQrcode.text
      const qrcodeConfiguration = jobPoster.qrcode_configuration
      const watermarkBgLocation = jobPoster.watermark_bg_location
      const watermarkBgUrl = jobPoster.watermark_bg_url
      const jobName = this.jobDetailInfo?.i18nName || this.$t('companyJobList.message.multipleJobs')
      const jobCity = this.jobDetailInfo?.cities || this.$t('companyJobList.message.multipleLocations')
      const jobCompany = this.company.i18nName
      const allInfo = {
        bgSourceUrl,
        bgSize,
        contentConfiguration,
        qrcodeUrl,
        qrcodeConfiguration,
        watermarkBgLocation,
        watermarkBgUrl,
        jobName,
        jobCity,
        jobCompany
      }
      return md5(JSON.stringify(allInfo))
    },
    getCurrentPosterList (showType) {
      if (showType === JOB_POSTER_SHOW_TYPE.COMMON) {
        return this.commonPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.CUSTOM) {
        return this.customPosterList
      } else if (showType === JOB_POSTER_SHOW_TYPE.INSTRUCTIONS) {
        return this.instructionsPosterList
      } else {
        return this.ambassadorPosterList
      }
    },
    async handleUploadPoster (fileInfo) {
      const file = fileInfo.file
      const fileType = file.type
      const language = this.isEn() === 'en' ? 'en' : 'cn'
      const fileKey = `ambassador-poster/${this.company.id}/${language}/${fileType}/${new Date().valueOf()}`
      this.jobPosterDialog.loading = true
      try {
        const resp = await uploadFile(file, fileKey)
        if (resp) {
          this.fileKey = resp.key
          const posterInfo = {
            company_id: this.company.id,
            job_poster_id: this.currentPopPoster.id,
            poster_url: fileKey
          }
          await this.uploadAmbassadorJobPoster(posterInfo)
          this.newJobPosterImages = []
          await this.fetchJobPoster()
          const posterList = this.getCurrentPosterList('AMBASSADOR_POSTER')
          this.onPosterPreviewClick(posterList[0])
        }
      } finally {
        this.jobPosterDialog.loading = false
      }
    },
    beforeUploadPoster (file) {
      const canUploadFileType = this.currentPopPoster.poster_type
      const fileType = file.type
      let msg = null

      if (/image/.test(fileType)) {
        if (file.size > ACCEPT_FILE_SIZE) {
          msg = this.$t('admin.company.jobPoster.message.wrongImageSize', { size: ACCEPT_FILE_SIZE / (1024 * 1024) })
        }
      } else if (/video/.test(fileType)) {
        const url = URL.createObjectURL(file)
        const audioElement = new Audio(url)
        audioElement.addEventListener('loadedmetadata', () => {
          this.newVideoJobPosterDuration = parseInt(audioElement.duration)
        })
        if (file.size > ACCEPT_VIDEO_FILE_SIZE || this.newVideoJobPosterDuration > ACCEPT_VIDEO_DURATION_SECONDS) {
          msg = this.$t('admin.company.jobPoster.message.wrongVideoSize', { size: ACCEPT_VIDEO_FILE_SIZE / (1024 * 1024), duration: ACCEPT_VIDEO_DURATION_SECONDS })
        }
      } else {
        msg = canUploadFileType === 'img' ? this.$t('admin.company.jobPoster.message.wrongImageType') : this.$t('admin.company.jobPoster.message.wrongVideoType')
      }

      if (msg) {
        this.$message.info({
          message: msg,
          customClass: 'message-override'
        })
        return false
      }

      return true
    },
    handleDownloadPoster () {
      const jobPoster = this.currentPopPoster
      if (jobPoster.poster_type === 'img') {
        const blob = base64SrcToBlob(jobPoster.bgImageSrc)
        const aEl = document.createElement('a')
        aEl.download = `${new Date().getTime()}.png`
        aEl.href = URL.createObjectURL(blob)
        aEl.click()
      } else {
        if (this.isGeneratingVideo) {
          this.$message.info({
            message: this.$t('jobDetail.videoIsGenerating'),
            customClass: 'message-override'
          })
          return
        }
        if (!jobPoster.videoKeyAfterCompound) {
          this.currentPopPoster = jobPoster
          this.isGeneratingVideo = true
          this.generateBgImage(jobPoster)
          return
        }
        const src = `${this.getSourcePath(jobPoster.videoKeyAfterCompound)}&attname=${new Date().getTime()}.mp4`
        window.location.href = src
      }
    },
    getVideoHeight (jobPoster, videoWidthPercent = 0.9) {
      const videoInfo = jobPoster.videoInfo
      if (!videoInfo) {
        return ''
      }
      const width = videoInfo.width
      const height = videoInfo.height
      if (!width || !height) {
        return ''
      }
      const screenWidth = document.body.clientWidth
      const imageWidth = screenWidth * videoWidthPercent
      const imageHeight = imageWidth * height / width
      return `${imageHeight}px`
    },
    onVideoLoaded () {
      const videoRef = this.$refs['poster-video']
      videoRef && videoRef.pause()
    },
    countShareTimesWithSite (site) {
      const jobId = this.jobDetailInfo.id
      this.countShareTimes({ job_id: jobId, channel: site })
    }
  }
}
</script>

<style lang="scss" scoped>
.job-poster-page {
  .job-poster {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .poster-preview-container {
      width: 45%;

      .image-container {
        width: 100%;
        position: relative;
        cursor: pointer;

        &.preview {
          cursor: initial;
        }

        .icon-video-play {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          .image-overlay {
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.33);
            border-radius: 4px;
          }

          .play-icon {
            width: 36px;
            height: 36px;
            z-index: 1;
          }
        }

        .image-wrapper {
          >img {
            border-radius: 4px;
            display: block;
            width: 100%;
            max-height: 290px;
            object-fit: cover;
          }
        }
      }
    }
  }
}

.job-poster-dialog {
  .job-poster-share {
    display: flex;
    margin-left: 10px;

    .job-poster-list {
      overflow: auto;
      margin-left: 40px;
      padding: 24px 20px;
      width: 240px;
      height: 592px;
      background-color: #fff;
      border-radius: 4px;

      .job-poster-item {
        padding-bottom: 24px;

        .header {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          line-height: 20px;
          color: #303133;
          margin-bottom: 12px;

          .view-more {
            font-size: 12px;
            color: #909399;
            cursor: pointer;
          }
        }

        .preview-content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;

          .image-container {
            position: relative;
            margin-bottom: 12px;

            &.is_active {
              border-radius: 6px;
              border: 2px solid var(--custom-color, #0096cc);

              .image-wrapper {
                width: 80px;
                height: 64px;
              }
            }

            .icon-video-play {
              position: absolute;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              .image-overlay {
                width: 100%;
                height: 100%;
                position: absolute;
                background-color: rgba(0, 0, 0, 0.33);
                cursor: pointer;
                border-radius: 4px;
              }

              .play-icon {
                width: 30px;
                z-index: 1;
                cursor: pointer;
              }
            }

            .image-wrapper {
              cursor: pointer;
              background-repeat: no-repeat;
              background-size: cover;
              border-radius: 4px;
              width: 84px;
              height: 68px;
              object-fit: cover;
            }
          }
        }
      }
    }

    .job-poster-detail {
      overflow: auto;
      margin-left: 40px;
      padding: 24px 20px;
      width: 230px;
      height: 592px;
      background-color: #fff;
      border-radius: 4px;

      .header {
        font-size: 14px;
        line-height: 20px;
        color: #303133;
        margin-bottom: 12px;

        .back {
          font-size: 16px;
          color: #686868;
          vertical-align: middle;
          margin-right: 6px;
          cursor: pointer;
        }

        .label {
          vertical-align: middle;
        }
      }

      .preview-content {
        .image-container {
          position: relative;
          margin-bottom: 12px;

          &.is_active {
            border-radius: 6px;
            border: 2px solid var(--custom-color, #0096cc);
          }

          .icon-video-play {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .image-overlay {
              width: 100%;
              height: 100%;
              position: absolute;
              background-color: rgba(0, 0, 0, 0.33);
              cursor: pointer;
              border-radius: 4px;
            }

            .play-icon {
              width: 30px;
              z-index: 1;
              cursor: pointer;
            }
          }

          .image-wrapper {
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: cover;
            width: 100%;
            height: 140px;
            border-radius: 4px;
          }
        }
      }
    }

    .job-poster-content {
      margin: 0 70px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;

      .poster {
        width: 518px;
        max-height: 540px;
        overflow: auto;
        margin: auto;

        .poster-video {
          width: 500px;
          border-radius: 4px;
        }

        .poster-img {
          width: 500px;
          border-radius: 4px;
        }
      }

      .btn-group {
        display: flex;
        height: 40px;

        .btn {
          margin: 0 6px;
        }

        .upload-btn {
          color: #fff;
          background-color: var(--custom-color, #0096cc);
          border-color: var(--custom-color, #0096cc);
        }

        .download-btn {
          color: #fff;
          background-color: var(--custom-color, #0096cc);
          border-color: var(--custom-color, #0096cc);
        }
      }
    }
  }

  &.common-dialog {
    ::v-deep {
      .el-dialog {
        width: 920px;
        background-color: #F5F5F5;

        .el-dialog__header {
          padding: 24px 0 0 0;
        }

        .el-dialog__body {
          padding: 0 0 24px 0;
        }
      }
    }
  }
}
</style>
